var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlyWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5c-2.206 0-4-2.019-4-4.5s1.794-4.5 4-4.5 4 2.019 4 4.5-1.794 4.5-4 4.5zm0-8c-1.654 0-3 1.57-3 3.5s1.346 3.5 3 3.5 3-1.57 3-3.5-1.346-3.5-3-3.5z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.5a.5.5 0 0 1-.5-.5c0-.199-.398-.5-1-.5s-1 .301-1 .5a.5.5 0 0 1-1 0c0-.841.879-1.5 2-1.5s2 .659 2 1.5a.5.5 0 0 1-.5.5zM13 10.5a.5.5 0 0 1-.488-.392L12 7.803l-.512 2.305a.5.5 0 0 1-.559.387l-3.5-.5a.5.5 0 0 1 .141-.99l3.042.435.764-3.44c.065-.294.322-.5.624-.5s.559.206.624.5l.764 3.44 3.042-.435a.5.5 0 0 1 .14.99l-3.5.5a.412.412 0 0 1-.07.005zM8.5 16.512h-8a.5.5 0 0 1-.5-.5v-.671c0-.72.514-1.34 1.222-1.474l7.186-1.358a.5.5 0 1 1 .186.982L1.407 14.85a.5.5 0 0 0-.407.491v.171h7.5a.5.5 0 0 1 0 1zM23.5 16.512h-8a.5.5 0 0 1 0-1H23v-.171a.5.5 0 0 0-.407-.491l-7.186-1.358a.5.5 0 1 1 .186-.982l7.186 1.358A1.5 1.5 0 0 1 24 15.341v.671a.5.5 0 0 1-.5.5z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 18.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5S7 16.173 7 17s-.673 1.5-1.5 1.5zm0-2a.5.5 0 1 0 .002 1.002A.5.5 0 0 0 5.5 16.5zM18.5 18.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-2a.5.5 0 1 0 .002 1.002.5.5 0 0 0-.002-1.002z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlyWhite);
export default __webpack_public_path__ + "static/media/flyWHITE.1e4ce920b0ab56a2b76de393aa7f038a.svg";
export { ForwardRef as ReactComponent };